import { countTypeEnum, QualityTypeEnum, spsaPrevOperationEnum } from "@gtpl/shared-models/common-models";

export class SPSAOperationViewModel{
    lotNumber ?: string;
    variant ?: string;
    quality ?: QualityTypeEnum;
    prevOperation ?: spsaPrevOperationEnum;
    inCountType ?: countTypeEnum;
    inCount ?: number;
    inQty ?: number;
    inProduct ?: string;
    outProductsInfo ?: OutProductsInfoModel[];
    totOutQty ?: number;
    yieldPer ?: number;
    workOderNumber ?: string;

    constructor(lotNumber ?: string,variant ?: string,quality ?: QualityTypeEnum,prevOperation ?: spsaPrevOperationEnum,inCountType ?: countTypeEnum,inCount ?: number,inQty ?: number,inProduct ?: string,outProductsInfo ?: OutProductsInfoModel[],totOutQty ?: number,yieldPer ?: number,workOrderNumber?:string){
        this.lotNumber = lotNumber
        this.variant = variant
        this.quality = quality
        this.prevOperation = prevOperation
        this.inCountType = inCountType
        this.inCount = inCount
        this.inQty = inQty
        this.inProduct = inProduct
        this.outProductsInfo = outProductsInfo
        this.totOutQty = totOutQty
        this.yieldPer = yieldPer
        this.workOderNumber = workOrderNumber
    }
}

export class OutProductsInfoModel{
    outCountType ?: countTypeEnum;
    outCount ?: number;
    outQty ?: number;
    outProduct ?: string;

    constructor(outCountType ?: countTypeEnum,outCount ?: number,outQty ?: number,outProduct ?: string){
        this.outCountType = outCountType
        this.outCount = outCount
        this.outQty = outQty
        this.outProduct = outProduct
    }
}

